@for (section of form.sections; track trackBySectionName($index, section)) {
	@if (section.isVisible) {
		<div class="row g-4 align-items-stretch">
			<div class="col-12 col-md-{{ section.width }} mb-3">
				<div class="row align-items-center">
					<div class="col-12 col-md-12">
						<h4>{{ section.name }}</h4>
					</div>

					@for (button of section.buttons; track trackByButtonLabel($index, button)) {
						<div class="col-auto">
							<button
								*ngIf="button.isVisible"
								[class]="button.class"
								[style]="button.style"
								(click)="button?.function()"
								type="button"
							>
								<i [class]="button.icon" aria-hidden="true"></i>
								<span>{{ button.label }}</span>
							</button>
						</div>
					}
				</div>

				<div class="row g-3 align-items-end">
					@for (field of section.fields; track trackByFieldName($index, field)) {
						@if (field.conditions.isVisible) {
							<div class="col-12 col-sm-{{ field.width }} mb-3">
								@if (isFieldReady(field)) {
									<app-field
										[form]="form"
										[field]="field"
										[model]="model"
										[undoEnabled]="undoEnabled"
										[originalModel]="originalModel"
										[filterInputParcelas]="filterInputParcelas"
										[fieldHelpTourAnchorId]="getFieldHelpTourAnchorId(field)"
										[sectionName]="section.name"
										[debug]="debug"
										[renderVersion]="renderVersion"
										[showFieldHelpButtons]="showFieldHelpButtons"
									>
									</app-field>
								} @else {
									<div class="w-100">
										<div class="field-label mb-1">
											<span class="fw-semibold">{{ field.label ?? field.name }}</span>

											@if (field.conditions.isRequired) {
												<span class="required-asterisk ms-1">*</span>
											}
										</div>

										@if (isFieldErrored(field)) {
											<div class="alert alert-warning py-2 mb-0" role="alert">
												{{ getFieldError(field) }}
											</div>
										} @else {
											<p-skeleton height="2.5rem" styleClass="w-100"></p-skeleton>
										}

										@if (getPendingDisplay(field)) {
											<small class="text-muted d-block mt-1"> Valor guardado: {{ getPendingDisplay(field) }} </small>
										}
									</div>
								}
							</div>
						}
					}
				</div>
			</div>

			<div class="col-12 col-md w-100">
				@if (section.tables !== null && form.type < 3) {
					<div class="d-flex flex-column gap-4 w-100">
						@for (table of section.tables; track trackByTableTitle($index, table)) {
							<app-reactive-form-table [table]="table"></app-reactive-form-table>
						}
					</div>
				}
			</div>
		</div>
	}
}
